import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchL22GamesData, fetchL22PolasData } from '../../store/actions/l22GameAction';
import Loading from '../Loading';

const L22Card = (data) => {
  const dispatch = useDispatch();
  const { l22Names, l22Images, l22Polas, nameAndImagesIsLoading } = useSelector((state) => state.l22GameReducer);

  useEffect(() => {
    dispatch(fetchL22PolasData());
    dispatch(fetchL22GamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading) return (
    <>
      <Loading />
    </>
  )

  return (
    <>
      <h2>L22</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="hb">
        <div className='grid grid-cols-2 lg:grid-cols-6 gap-4 justify-items-center'>
          {
            l22Names.map((l22Name, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={l22Images[i]} alt={l22Name} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{l22Name}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value13 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v">{l22Polas[i] ? `${l22Polas[i].value1} - ${l22Polas[i].value2} - ${l22Polas[i].value3}` : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value13 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value13 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default L22Card;